import { put, take, select, call } from "redux-saga/effects";

// Classes
import { ITEMS_LIST } from "../../Classes/utils/constants";

// Store
import { gameDataActions, GAME_DATA_ACTIONS } from "../Actions/gameDataActions";
import { EVENT_ACTIONS } from "../Actions/eventActions";
import { heroActions } from "../Actions/heroActions";
import { logsActions } from "../Actions/logsActions";

import {
	getHeroInventory,
	getHeroGold,
	getHeroName,
	getMonsters,
} from '../Selectors/selectors';
import { log } from "../../Helpers/logger";

import { FIGHT_SAGA_RESULTS } from "./fightSaga";
import { startFight } from "../Sagas/sagaHelpers";

// Helpers
import { checkInventoryStackcountByItemId } from '../../Helpers/utils'
import { SCRIPT_ACTION_TYPE, GAME_STATE, MODAL_FLAG } from "../../Helpers/constants";


// ============================================================================

// ----------------------------------------------------------------------------
function getStartingEventData(event) {
    const { scripts, scriptId, defaultSpeaker, defaultMessage } = event;

    const script = scripts[scriptId];
    const { speaker, message, actions } = script;

    return {
        speaker: speaker ? speaker : defaultSpeaker,
        message: message ? message : defaultMessage,
        actions,
    };
}

// ----------------------------------------------------------------------------
function updateEventData(eventData, script) {
    const { speaker, message, actions } = script;
    let payload = {
        actions
    };
    if (speaker) {
        payload['speaker'] = speaker;
    }

    if (message) {
        payload['message'] = message;
    }

    return {
        ...eventData,
        ...payload
    }
}

// ============================================================================

function* eventSaga(event){
    log.saga.log('eventSaga -> start', event);
    let currentScriptId = event.scriptId;
    let eventData = yield call(getStartingEventData, event);
    
    yield put(gameDataActions.setEventData(eventData));
    yield put(gameDataActions.modalData.set(true, MODAL_FLAG.EVENT));
    yield put(gameDataActions.setGameState(GAME_STATE.MODAL));

    while(true) {
        log.saga.log('eventSaga', currentScriptId, eventData);
        let eventAction = yield take(
            Object.values(EVENT_ACTIONS).map((action) => action),
        );
        log.saga.log('eventSaga eventAction', eventAction);
        
        let applyNextScriptIdCheck = true;
        switch (eventAction.type) {
            case EVENT_ACTIONS.SEND_ACTION_INDEX: {
                const { actionIndex } = eventAction.payload;
                const action = eventData.actions[actionIndex]
                log.saga.log('action', action);

                if (!action) {
                    const error = new Error(`Invalid actionIndex: ${actionIndex}`);
                    console.error(error.message);
                    // On pourrait aussi dispatcher une action d'erreur ici
                    // yield put(actions.eventError(error.message));
                    return { error: error.message };
                }

                switch (action.type) {
                    case SCRIPT_ACTION_TYPE.TAKE_ITEM: {
                        log.saga.log("eventSaga takeItem", action);
                        // extraData correspond aux objets à donner au joueur
                        const { extraData } = action;
                        if (!extraData) {
                            const error = new Error('eventSaga takeItem -> extraData should not be empty');
                            console.error(error.message);
                            // On pourrait aussi dispatcher une action d'erreur ici
                            // yield put(actions.eventError(error.message));
                            return { error: error.message };
                        }

                        const heroInventory = yield select(getHeroInventory);
                        const heroName = yield select(getHeroName);

                        for (let index = 0; index < extraData.length; index++) {
                            const item = extraData[index];
                            const  [ itemId, quantityItem ] = item;
                            log.saga.log(item, itemId, quantityItem);
                            if (checkInventoryStackcountByItemId(heroInventory, itemId, quantityItem)) {

                                let slotId, slotIdOfNull;
                                let quantityItemInt = parseInt(quantityItem);

                                Object.values(heroInventory).forEach((slot, index) => {
                                    if (slot) {
                                        log.saga.log("il y a un slot", slot);
                                        if (slot.item.id  === itemId) {
                                            log.saga.log("test1", slot);
                                            slotId = "slot" + (index+1);
                                        } else {
                                            log.saga.log("non");
                                        }
                                    } else if (!slotIdOfNull) {
                                        log.saga.log("slot vide ");
                                        slotIdOfNull = "slot" + (index+1);
                                    }
                                })

                                if (slotId) {
                                    yield put(heroActions.addItemQuantity(slotId, quantityItemInt));  
                                    yield put(logsActions.add(heroName + " à recu " + quantityItemInt + " " + ITEMS_LIST[itemId].name));
                                } else {
                                    yield put(heroActions.addItemQuantity(slotIdOfNull, quantityItemInt, itemId)); 
                                    yield put(logsActions.add(heroName + " à recu " + quantityItemInt + " " + ITEMS_LIST[itemId].name));
                                }
                            } else {
                                if ('inventoryFull' in event.scripts) {
                                    log.saga.log('inventoryFull');
                                } else {
                                    log.saga.log('inventoryFull default');
                                    eventData = {
                                        ...eventData,
                                        message: 'Fais un peu de place dans ton inventaire !',
                                        actions: [
                                            {
                                                type: SCRIPT_ACTION_TYPE.END_EVENT,
                                                label: "Ok",
                                            }
                                        ]
                                    };

                                    yield put(gameDataActions.setEventData(eventData));

                                    eventAction = yield take(
                                        Object.values(EVENT_ACTIONS).map((action) => action),
                                    );
                                    log.saga.log('eventSaga eventAction', eventAction);
                                }
                                // yield put( logsActions.add(heroName + " n'a pas de place sur lui !") );
                            }
                        }

                        break;
                    }
                    case SCRIPT_ACTION_TYPE.START_FIGHT: {
                        log.saga.log("eventSaga startFight", action);
                        // extraData correspond aux identifiants des monstres pour le combat
                        const { extraData } = action;
                        if (!extraData) {
                            console.error('eventSaga startFight -> extraData should not be empty');
                            return;
                        }
                        log.saga.log(extraData);
                        let monsters = yield select(getMonsters);

                        yield put(gameDataActions.generateFightData({
                            monsterIds: extraData, monsters
                        }));
                        yield put( gameDataActions.setToFightMode() );
                        yield put( gameDataActions.modalData.switch() );

                        const fightSagaResult = yield call(startFight);
                        log.saga.log('eventSaga fightResult', fightSagaResult);

                        switch (fightSagaResult) {
                            case FIGHT_SAGA_RESULTS.PLAYER_DEAD: {
                                if ('endFightDead' in event.scripts) {
                                    log.saga.log('endFightDead');
                                    eventData = updateEventData(eventData, event.scripts['endFightDead']);
                                } else {
                                    log.saga.log('endFightDead default');
                                    eventData = {
                                        ...eventData,
                                        message: 'HA HA HA HA HAAAAA !',
                                        actions: [
                                            {
                                                type: SCRIPT_ACTION_TYPE.END_EVENT,
                                                label: "...",
                                            }
                                        ]
                                    };
                                }

                                break;
                            }
                            case FIGHT_SAGA_RESULTS.PLAYER_ESCAPE: {
                                if ('endFightEscape' in event.scripts) {
                                    log.saga.log('endFightEscape');
                                    eventData = updateEventData(eventData, event.scripts['endFightEscape']);
                                } else {
                                    log.saga.log('endFightEscape default');
                                    eventData = {
                                        ...eventData,
                                        message: 'Et que je ne te revois plus, tocard !',
                                        actions: [
                                            {
                                                type: SCRIPT_ACTION_TYPE.END_EVENT,
                                                label: "*Serre les dents de colère, les yeux embués de larmes, tout en fuyant au plus loin*",
                                            }
                                        ]
                                    };
                                }

                                break;
                            }    
                            case FIGHT_SAGA_RESULTS.PLAYER_VICTORY: {
                                if ('endFightVictory' in event.scripts) {
                                    log.saga.log('endFightVictory');
                                    eventData = updateEventData(eventData, event.scripts['endFightVictory']);
                                } else {
                                    log.saga.log('endFightVictory default');
                                    eventData = {
                                        ...eventData,
                                        message: 'Steuplé me frappe plus !',
                                        actions: [
                                            {
                                                type: SCRIPT_ACTION_TYPE.END_EVENT,
                                                label: "Ok",
                                            }
                                        ]
                                    };

                                    yield take(GAME_DATA_ACTIONS.SET_TO_NORMAL_MODE);
                                }

                                break;
                            }
                            default: {  
                                console.error('eventSaga startFight -> Invalid fightSagaResult : ' + fightSagaResult);
                                return;
                            }
                        }

                        yield put(gameDataActions.setEventData(eventData));
                        yield put(gameDataActions.modalData.set(true, MODAL_FLAG.EVENT));
                        yield put(gameDataActions.setGameState(GAME_STATE.MODAL));

                        break;
                    }
                    case SCRIPT_ACTION_TYPE.GIVE_GOLD: {
                        log.saga.log("eventSaga giveGold", action);
                        // extraData correspond à la somme de gauld que le joueur donne
                        let { extraData } = action;
                        if (!extraData) {
                            console.error('eventSaga giveGold -> extraData should not be empty');
                            return;
                        }
                        
                        const heroGold = yield select(getHeroGold);
                        if (heroGold > 0) {
                            const heroName = yield select(getHeroName);
                            const goldDiff = heroGold - extraData;
                            log.saga.log(goldDiff);
                            if (goldDiff < 0) {
                                extraData += goldDiff
                            }
                            
                            yield put( heroActions.updateGold(-extraData) );
                            yield put( logsActions.add(heroName + " lui a donné " + (extraData) + " gauld.") );
                        } else {
                            if ('noGold' in event.scripts) {
                                eventData = updateEventData(eventData, event.scripts['noGold']);
                            } else {
                                eventData = {
                                    ...eventData,
                                    message: 'Et en plus t\'es fauché ! Tu fais pitié !',
                                    actions: [
                                        {
                                            type: SCRIPT_ACTION_TYPE.END_EVENT,
                                            label: "Quelle humiliation...",
                                        }
                                    ]
                                };
                            }

                            yield put(gameDataActions.setEventData(eventData));
                            applyNextScriptIdCheck = false;
                        }
                        
                        break;
                    }
                    case SCRIPT_ACTION_TYPE.END_EVENT: {
                        yield put(gameDataActions.modalData.switch());
                        yield put(gameDataActions.setToNormalMode());

                        return;
                    }
                    default:
                        console.error('Invalid script action type : ' + action.type);
                        break;
                }

                if (applyNextScriptIdCheck) {
                    const { nextScriptId } = action;
                    if (nextScriptId) {
                        eventData = yield call(updateEventData, eventData, event.scripts[nextScriptId]);
                        log.saga.log('updated eventData', eventData);
                        yield put(gameDataActions.setEventData(eventData));
                    }
                }
                
                break;
            }
            default:
                break;
        }
    }
}

export default eventSaga;